import { DocumentFolder } from '../../core-models';
import {
    buildEnumNameMap,
    getEnumValueByName,
    isEnumName,
} from './enum-name-format';

const DOCUMENT_FOLDER_SOURCE_LABELS = {
    Other: 'Other',
    HealthSafetyAndCompliance: 'Health, Safety & Compliance',
    ConstructionAndDevelopment: 'Construction & Development',
    BuildingOperationsAndFacilities: 'Building Operations & Facilities',
    Drawings: 'Drawings',
    EnvironmentalAndSite: 'Environmental & Site',
    PropertyAndLegal: 'Property & Legal',
    FinanceAndInsurance: 'Finance & Insurance',
} as const satisfies Readonly<Record<keyof typeof DocumentFolder, string>>;

export type DocumentFolderName =
    (typeof DOCUMENT_FOLDER_SOURCE_LABELS)[keyof typeof DOCUMENT_FOLDER_SOURCE_LABELS];

export const DocumentFolderName = buildEnumNameMap(
    DocumentFolder,
    DOCUMENT_FOLDER_SOURCE_LABELS
);

export function getDocumentFolderName(
    documentFolder: DocumentFolder
): DocumentFolderName {
    return DocumentFolderName[documentFolder];
}

export function getDocumentFolder(
    documentFolderName: DocumentFolderName
): DocumentFolder {
    const documentFolder = getEnumValueByName(
        DocumentFolderName,
        documentFolderName
    );

    if (documentFolder !== null) {
        return documentFolder;
    }

    throw new TypeError(
        `No DocumentFolder found for name: ${documentFolderName}`
    );
}

export function isDocumentFolderName(
    documentFolderName: string
): documentFolderName is DocumentFolderName {
    return isEnumName(DocumentFolderName, documentFolderName);
}
